import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// reducers
import { ManageModuli as ManageModuliReducer } from '../../reducers/r_index';
import { SetCodiceModuli as SetCodiceModuliReducer } from '../../reducers/r_index';
import { InsertModuli as InsertModuliReducer } from '../../reducers/r_index';
import { SetSerialNumberOld as SetSerialNumberOldReducer } from '../../reducers/r_index';
import { MultiViewGestioneLicenze as MultiViewReducer } from '../../reducers/r_index';
import { GetLicenses as GetLicensesReducer } from '../../reducers/r_index';
import { FilterLicenses as FilterLicensesReducer } from '../../reducers/r_index';
import { GetLicenseDetails as GetLicenseDetailsReducer } from '../../reducers/r_index';
import { IsSerialOldUsed as IsSerialOldUsedReducer } from '../../reducers/r_index';

//Components
import GestioneModuliCmp from '../../components/gestione_licenze/GestioneModuliCmp';

//utils
import { startOfToday, parseJSON } from 'date-fns';

// Material helpers
import { withStyles } from '@material-ui/core';

// Component styles
const styles = theme => ({
});



class GestioneModuli extends Component {

    componentDidMount() {

        const { selected_license_tmp, selected_license, product_key, initializeField, initializeConfigurations, getCodiceModuli, getLicenseDetails } = this.props;

        //se è prima attivazione ed arrivo da 'Crea Licenza' allora ricavo tutti i dati della licenza tramite la chiamata al web service
        if (this.props.prima_attivazione === true) {
            getLicenseDetails(product_key);
        }
        else { //altrimenti ricavo i dati dalla licenza selezionata nella griglia e dal web service ricavo solo il codice moduli

            initializeField('selected_license', selected_license_tmp);
            initializeField('tipologia', selected_license_tmp.Tipologia);
            initializeConfigurations(this.props.lista_licenze, selected_license_tmp.ProductKey);

            getCodiceModuli(selected_license_tmp.ProductKey, selected_license_tmp.IDModulo, selected_license_tmp.Tipologia);

            // se DataDecorr è null, data_decorrenza viene inizializzato a data di oggi
            if (selected_license_tmp.DataDecorr !== null)
                initializeField('data_decorrenza', parseJSON(selected_license_tmp.DataDecorr));
            else initializeField('data_decorrenza', startOfToday());

            // se SerialNumberOld è null, serial_number_old viene inizializzato a ''
            if (selected_license_tmp.SerialNumberOld !== null)
                initializeField('serial_number_old', selected_license_tmp.SerialNumberOld);
            else initializeField('serial_number_old', '');
        }

    }

    async componentDidUpdate(propsPrecedenti) {
        const { initializeField, new_license, getCodiceModuli } = this.props;

        //l'unico momento in cui new_license cambia da {} a object è quando si passa dalla view 'Crea Licenza' a 'Gestione Moduli'
        if (new_license !== propsPrecedenti.new_license) {

            if (new_license !== {}) {

                new_license.SerialNumberOld = '';

                await initializeField('selected_license', new_license);
                getCodiceModuli(new_license.ProductKey, new_license.IDModulo, new_license.Tipologia);

            }
        }
    }

    render() {
        const { ...props } = this.props;

        return (
            <GestioneModuliCmp {...props} />
        );

    }
}

GestioneModuli.propTypes = {

    //manageModuli
    getCodiceModuli: PropTypes.func.isRequired,
    getCodiceModuliRequestStatus: PropTypes.string.isRequired,

    moduli: PropTypes.shape({}).isRequired,
    new_moduli: PropTypes.shape({}).isRequired,

    data_decorrenza: PropTypes.instanceOf(Date),
    serial_number_old: PropTypes.string,

    isValid: PropTypes.bool.isRequired,
    isModuliChanged: PropTypes.bool.isRequired,
    isDataDecorrChanged: PropTypes.bool.isRequired,
    isSNOldChanged: PropTypes.bool.isRequired,

    handleChangeFieldModulo: PropTypes.func.isRequired,
    handleChangeField: PropTypes.func.isRequired,
    setAllActive: PropTypes.func.isRequired,
    onProfiloPredefChange: PropTypes.func.isRequired,
    validateField: PropTypes.func.isRequired,
    validateSNOld: PropTypes.func.isRequired,

    tipologia: PropTypes.string.isRequired,
    profilo_predefinito: PropTypes.string.isRequired,
    prima_attivazione: PropTypes.bool.isRequired,
    errorText: PropTypes.shape({}).isRequired,

    //setCodiceModuli
    setCodiceModuli: PropTypes.func.isRequired,
    setCodiceModuliRequestStatus: PropTypes.string.isRequired,
    isInserted_SetCodiceModuli: PropTypes.string.isRequired,

    //insertModuli
    insertModuli: PropTypes.func.isRequired,
    insertModuliRequestStatus: PropTypes.string.isRequired,
    isInserted_InsertModuli: PropTypes.string.isRequired,

    //getLicenseDetails
    getLicenseDetails: PropTypes.func.isRequired,
    getLicenseDetailsRequestStatus: PropTypes.string.isRequired,
    resetLicenseDetails: PropTypes.func.isRequired,

    //setSerialNumberOld
    setSerialNumberOld: PropTypes.func.isRequired,
    setSerialNumberOldRequestStatus: PropTypes.string.isRequired,

    //isSerialOldUsed
    isSerialOldUsed: PropTypes.func.isRequired,
    is_serial_old_used: PropTypes.bool.isRequired,

    resetModuli: PropTypes.func.isRequired,
    changeViewSelection: PropTypes.func.isRequired,

    lista_licenze: PropTypes.arrayOf(PropTypes.object).isRequired,
    selected_license: PropTypes.shape({
        ProductKey: PropTypes.any,
        SerialNumber: PropTypes.any,
        ID: PropTypes.any,
        SerialNumberOld: PropTypes.any,
        IDModulo: PropTypes.any,
        Tipologia: PropTypes.any,
        DataDecorr: PropTypes.any,
        DataScadenza: PropTypes.any,
    }).isRequired,

    selected_license_tmp: PropTypes.shape({
        ProductKey: PropTypes.any,
        SerialNumber: PropTypes.any,
        ID: PropTypes.any,
        SerialNumberOld: PropTypes.any,
        IDModulo: PropTypes.any,
        Tipologia: PropTypes.any,
        DataDecorr: PropTypes.any,
        DataScadenza: PropTypes.any,
    }),

    codiceUtente: PropTypes.string.isRequired,

    //griglia licenze
    refreshLicenses: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,
};


const mapDispatchToProps = dispatch => ({
    //manageModuli
    getCodiceModuli: (pk, IDModulo, tipologia) => { dispatch(ManageModuliReducer.creators.getCodiceModuliRequest(pk, IDModulo, tipologia)) },
    initializeField: (field, value) => { dispatch(ManageModuliReducer.creators.initializeField(field, value)) },
    initializeConfigurations: (lista_licenze, pk) => { dispatch(ManageModuliReducer.creators.initializeConfigurations(lista_licenze, pk)) },
    validateField: (field) => { dispatch(ManageModuliReducer.creators.validateField(field)) },
    validateSNOld: (is_serial_old_used) => { dispatch(ManageModuliReducer.creators.validateSNOld(is_serial_old_used)) },

    handleChangeFieldModulo: (mainField, field, newValue) => { dispatch(ManageModuliReducer.creators.handleChangeFieldModulo(mainField, field, newValue)) },
    handleChangeField: (field, newValue) => { dispatch(ManageModuliReducer.creators.handleChangeField(field, newValue)) },
    onProfiloPredefChange: (new_prof_pred) => { dispatch(ManageModuliReducer.creators.onProfiloPredefChange(new_prof_pred)) },
    setAllActive: (new_moduli) => { dispatch(ManageModuliReducer.creators.setAllActive(new_moduli)); },
    resetModuli: () => { dispatch(ManageModuliReducer.creators.resetModuli()) },

    //setCodiceModuli
    setCodiceModuli: (pk, IDModulo, dataDecorr, codiceUtente, tipologia, sn, moduli) => { dispatch(SetCodiceModuliReducer.creators.setCodiceModuliRequest(pk, IDModulo, dataDecorr, codiceUtente, tipologia, sn, moduli)) },

    //insertModuli
    insertModuli: (pk, IDLicenza, dataDecorr, codiceUtente, tipologia, sn, moduli) => { dispatch(InsertModuliReducer.creators.insertModuliRequest(pk, IDLicenza, dataDecorr, codiceUtente, tipologia, sn, moduli)) },

    //setSerialNumberOld
    setSerialNumberOld: (pk, IDLicenza, new_sn_old, codiceUtente) => { dispatch(SetSerialNumberOldReducer.creators.setSerialNumberOldRequest(pk, IDLicenza, new_sn_old, codiceUtente)) },


    //getLicenseDetails
    getLicenseDetails: (pk) => { dispatch(GetLicenseDetailsReducer.creators.getLicenseDetailsRequest(pk)) },
    resetLicenseDetails: () => { dispatch(GetLicenseDetailsReducer.creators.resetLicenseDetails()) },

    //isSerialOldUsed
    isSerialOldUsed: (sn_old, pk) => { dispatch(IsSerialOldUsedReducer.creators.isSerialOldUsedRequest(sn_old, pk)) },

    //griglia licenze
    refreshLicenses: (codiceUtente) => { dispatch(GetLicensesReducer.creators.getLicensesRequest(codiceUtente)); },
    resetFilters: () => { dispatch(FilterLicensesReducer.creators.resetFilters()) },

    changeViewSelection: newView => dispatch(MultiViewReducer.creators.changeViewSelection(newView)),
});

const mapStateToProps = state => ({

    //getCodiceModuli
    getCodiceModuliRequestStatus: state['gestione-moduli'].status,

    // license_configurations: state['gestione-moduli'].license_configurations,


    //manageModuli
    moduli: state['gestione-moduli'].moduli,
    new_moduli: state['gestione-moduli'].new_moduli,


    selected_license: state['gestione-moduli'].selected_license,
    prima_attivazione: state['gestione-moduli'].prima_attivazione,
    product_key: state['gestione-moduli'].product_key,
    tipologia: state['gestione-moduli'].tipologia,
    data_decorrenza: state['gestione-moduli'].data_decorrenza,
    serial_number_old: state['gestione-moduli'].serial_number_old,

    isValid: state['gestione-moduli'].isValid,
    isModuliChanged: state['gestione-moduli'].isModuliChanged,
    isDataDecorrChanged: state['gestione-moduli'].isDataDecorrChanged,
    isSNOldChanged: state['gestione-moduli'].isSNOldChanged,

    profilo_predefinito: state['gestione-moduli'].profilo_predefinito,

    errorText: state['gestione-moduli'].errorText,

    //setCodiceModuli
    setCodiceModuliRequestStatus: state['set-moduli'].status,
    isInserted_SetCodiceModuli: state['set-moduli'].isInserted,

    //insertModuli
    insertModuliRequestStatus: state['insert-moduli'].status,
    isInserted_InsertModuli: state['insert-moduli'].isInserted,

    //setSerialNumberOld
    setSerialNumberOldRequestStatus: state['set-old-serial-number'].status,

    //getLicenseDetails
    getLicenseDetailsRequestStatus: state['dettagli-licenza'].status,
    new_license: state['dettagli-licenza'].licenza,

    //isSerialOldUsed
    is_serial_old_used: state['is-serial-old-used'].is_serial_old_used,


    lista_licenze: state['licenze'].lista_licenze,
    selected_license_tmp: state['filtro-licenze'].selected_license,

    codiceUtente: state['logged-user'].codiceUtente,
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(GestioneModuli));